import { useCallback, useMemo, useState } from 'react';

import { mergeRight } from 'ramda';

import { getDefaultLandingV2Config, getLandingV2Config } from 'detailsv2/LandingV2/functions';
import { ILandingConfig } from 'detailsv2/LandingV2/types';
import { IProposal } from 'utils/itineraryDetails/types';

import { addDataToProposalBlocks } from '../Admin/shared/functions';

export const useLandingV2Preview = ({
  data,
  additionalConfig = {},
}: {
  data: IProposal;
  additionalConfig?: Partial<ILandingConfig>;
}) => {
  const [isContactsModalOpen, setIsContactsModalOpen] = useState(false);
  const filteredPages = useMemo(
    () => data.landing.pages.filter((page) => !page.hidden && !page.empty),
    [data.landing.pages],
  );
  const proposal = useMemo(
    () =>
      addDataToProposalBlocks({
        ...data,
        landing: { pages: filteredPages },
      }),
    [data, filteredPages],
  );
  const contactsModalHandler = useCallback(() => setIsContactsModalOpen((prev) => !prev), []);
  const consultantName =
    data.brandSettings.firstName && `${data.brandSettings?.firstName} ${data.brandSettings?.lastName}`;

  const config = useMemo(() => {
    let res = { ...getDefaultLandingV2Config(), settings: data.settings };

    if (data.landingConfig) {
      res = mergeRight(res, data.landingConfig);
    }

    return getLandingV2Config({ ...res, ...additionalConfig });
  }, [data, additionalConfig]);

  return {
    proposal,
    config,
    isContactsModalOpen,
    contactsModalHandler,
    consultantName,
  };
};
